module.exports = __webpack_public_path__ + "static/img/icon_ek.8381e125.png";